import { createFileRoute } from "@tanstack/react-router";

// `tab` = the CSKH list tab the order was opened from ("Sửa hình" or "Ảnh
// thẻ"), so "← Danh sách" returns there. Entries from elsewhere (order page,
// print table) carry none and the list opens on its first tab as before.
type CskhOrderSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/cskh/$orderId")({
  validateSearch: (search: Record<string, unknown>): CskhOrderSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
